<template>
  <div class="mega-menu">
    <div ref="content"
         class="mega-menu__content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "MegaMenu",
};
</script>

<style lang="less" scoped>
.mega-menu {
  animation: fadein 0.2s;

  &__content {
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    z-index: 200;
    background: #fff;
    display: flex;
    border-top: 1px solid #d6d6d6;
    padding: 1.875rem 1rem;
    box-shadow: 0 15px 15px rgba(33, 33, 33, 0.25);
  }

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @media (max-width: 991px) {
    display: none;
  }
}
</style>
